import React, { useRef, useState } from 'react';
import useClickOutside from '../../../../../../../common/hooks/useClickOutside';
import { createPortal } from 'react-dom';

import Icon from '../../../../../../ui/icon/icon';

import './gridHeaderCell.scss';

const notesElement = document.getElementById('notes-root');

const GridHeaderCell = ({ title, item }) => {
  const [notesShown, setNotesShown] = useState<any>({ showNote: '' });
  const [notesXAxis, setNotesXAxis] = useState<number>(0);
  const [notesYAxis, setNotesYAxis] = useState<number>(0);

  const toggleNotes = (e, id): void => {
    setNotesXAxis(e.pageX);
    setNotesYAxis(e.pageY);
    setNotesShown({ showNote: id });
  };

  const clickOutsideHandler = (): void => {
    setNotesShown({ showNote: '' });
  };

  const wrapperRef = useRef(null);
  useClickOutside(wrapperRef, clickOutsideHandler, `grid-header-${item.columnId}`);

  return (
    <div className="grid-header-item-name">
      <span className="grid-header-item" style={{ marginRight: item.hasNotes ? 6 : 0 }}>
        {title}
      </span>
      {item.hasNotes && (
        <div className="notes-wrapper">
          <Icon
            name={`${notesShown.showNote === item.columnId ? 'far' : 'fas'} fa-circle`}
            className="notes-info"
            onClick={(e) => {
              toggleNotes(e, item.columnId);
            }}
            id={`grid-header-${item.columnId}`}
          />
          {notesShown.showNote === item.columnId && createPortal(
            <div className="notes-content" ref={wrapperRef} style={{top: `${notesYAxis - 50}px`, left: `${notesXAxis + 10}px`}}>
              {item.notes &&
                item.notes.map((note, key) => (
                  <p key={key}>
                    {note.symbol} {note.note}
                  </p>
                ))}
            </div>, notesElement
          )}
        </div>
      )}
    </div>
  );
};

export default GridHeaderCell;
